import { render, staticRenderFns } from "./ReadingExerciseUpdate.vue?vue&type=template&id=10049636&scoped=true&"
import script from "./ReadingExerciseUpdate.vue?vue&type=script&lang=ts&"
export * from "./ReadingExerciseUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./ReadingExerciseUpdate.vue?vue&type=style&index=0&id=10049636&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10049636",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VInput } from 'vuetify/lib/components/VInput';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDivider,VInput,VProgressCircular,VTextField})
